var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.137,
    height: 18.112,
    viewBox: "0 0 18.137 18.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M7.431,10.15a.906.906,0,1,0,.906.906A.906.906,0,0,0,7.431,10.15Zm3.622,0a.906.906,0,1,0,.906.906A.906.906,0,0,0,11.053,10.15Zm3.622,0a.906.906,0,1,0,.906.906A.906.906,0,0,0,14.675,10.15ZM11.053,2A9.056,9.056,0,0,0,2,11.056a8.956,8.956,0,0,0,2.047,5.732L2.233,18.6a.883.883,0,0,0,.67,1.512h8.15A9.056,9.056,0,1,0,11.053,2Zm0,16.3H5.085l.842-.842a.886.886,0,0,0,0-1.277A7.245,7.245,0,1,1,11.053,18.3Z",
    transform: "translate(-1.972 -2)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f3c6743cdfcb5f16916b179fd6c92580.svg";
export { ForwardRef as ReactComponent };